import { notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { paymentStatusActions } from "redux/actions/paymentStatusActions";
import { RootState } from "redux/rootReducer";
import { logo } from "assets/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { copy } from "assets/icons/index";
import { HOME_PATH } from "Routes/paths";

const Transaction = () => {
  // const [timeLeft, setTimeLeft] = useState(20);
  const { i18n, t } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  // const { id } = useParams<{ id: string }>();

  ///////////// gettin the ref id
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const transaction_Id = searchParams.get("ref");

  useEffect(() => {
    dispatch(paymentStatusActions(transaction_Id));
  }, [dispatch, transaction_Id]);

  const { paymentStatusLoading, paymentStatus } = useSelector(
    (state: RootState) => state.paymentStatusReducer
  );

  const onCopy = () => {
    notification.success({
      message: "Copied To Clipboard",
    });
  };

  ///////////// handle count down timer
  // useEffect(() => {
  //   if (timeLeft > 0) {
  //     const timerId = setInterval(() => {
  //       setTimeLeft((prev) => prev - 1);
  //     }, 1000);

  //     return () => clearInterval(timerId);
  //   }
  // }, [timeLeft]);

  // handle converting the date and time
  function formatTimestamp(timestamp: string): string {
    const date = new Date(timestamp);

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short",
    };

    return date.toLocaleDateString("en-US", options);
  }

  const readableDate = formatTimestamp(paymentStatus?.created_on)
    .split(" ")
    .slice(0, -2)
    .join(" ");

  // if (timeLeft === 0) {
  //   navigate(HOME_PATH);
  // }

  // console.log(paymentStatus?.receipt_url);

  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="300"
      className={`fixed top-0 left-0 z-[50] w-full h-screen bg-black/70 flex items-center justify-center px-[20px] ${
        i18n.language === "en" ? "font-Poppins" : "font-Almarai"
      }`}
    >
      <Spin spinning={paymentStatusLoading}>
        <div className="md:w-[424px] p-[25px] bg-white rounded-[20px] flex flex-col gap-5 font-[500] text-[16px]">
          {/* logo  ******************/}
          <div className="w-full flex items-center justify-center">
            <img
              onClick={() => navigate("/")}
              className="cursor-pointer"
              src={logo}
              alt=""
            />
          </div>

          {/* recipt number  ***********/}
          <div className=" flex items-center justify-between gap-6 ">
            <p>
              {t("Receipt")}:
              <p className=" text-[12px] font-[800]">
                {" "}
                {/* # {paymentStatus?.ref_id}{" "} */}
                <CopyToClipboard
                  onCopy={onCopy}
                  text={`${paymentStatus?.ref_id}`}
                >
                  <p className="flex items-center gap-2">
                    # {paymentStatus?.ref_id}{" "}
                    <img className="cursor-pointer" src={copy} alt="" />
                  </p>
                </CopyToClipboard>
              </p>
            </p>

            {paymentStatus?.status === false ? (
              <p className="font-[600] text-red-600">{t("FAILED")}</p>
            ) : (
              <p className="font-[600] text-green-600">{t("SUCCESS")}</p>
            )}
          </div>

          {/* date  *********************/}
          <div className="pb-3 border-b-[1px] border-[#E4E4E4]">
            {readableDate}
          </div>

          {/* project details  **********/}
          <div className="flex items-center justify-between ">
            <p>{t("Project Namezz")}</p>
            <div className="p-2 text-[13px] font-[700] max-h-24 overflow-auto">
              {i18n.language === "en" ? (
                <>
                  {paymentStatus?.projects?.internal_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_en} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.seasonal_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_en} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.campaign_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_en} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.external_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_en} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.humanitarian_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_en} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                </>
              ) : (
                <>
                  {paymentStatus?.projects?.internal_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_ar} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.seasonal_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_ar} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.campaign_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_ar} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.external_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_ar} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                  {paymentStatus?.projects?.humanitarian_projects?.map(
                    (item: any, i: number) => (
                      <p key={i}>
                        {item?.title_ar} &#40; {item?.amount} &#41;
                      </p>
                    )
                  )}
                </>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between">
            <p>{t("Total Amount")}</p>
            <p className="font-[800]">
              {paymentStatus?.amount} {t("AED")}
            </p>
          </div>

          <div className="flex items-center justify-between gap-4 lg:gap-8">
            <button
              onClick={() => navigate(HOME_PATH)}
              className="w-full h-[40px] bg-first_color text-white rounded-[15px] "
            >
              {t("Home")}
            </button>
            <button
              onClick={() => window.open(paymentStatus?.receipt_url)}
              className="w-full h-[40px] bg-first_color text-white rounded-[15px] "
            >
              {t("Download Receipt")}
            </button>
          </div>

          {/* <p className="w-full flex items-center justify-center  font-[500]">
            {t("Navigating to home page in:")}{" "}
            <span className="text-first_color text-[25px]"> {timeLeft}</span>
          </p> */}
        </div>
      </Spin>
    </section>
  );
};

export default Transaction;
